<template>
  <div id="goodsDetail">
    <div style="margin-bottom:20px">
      <el-date-picker
        v-model="dateTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        @change="dateTimeChange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <span style="padding: 0 10px 0 40px;box-sizing:border-box;">排序</span>
      <el-select v-model="value1" placeholder="请选择">
        <el-option
          v-for="item in options1"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span style="padding: 0 10px 0 40px;box-sizing:border-box;">
        <el-button type="primary" @click="search">搜索</el-button>
      </span>
    </div>
    <div class="content-container">
      <el-table
        :data="goodsData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%"
      >
        <el-table-column align="center" property="saleDate" label="日期" />
        <el-table-column align="center" property="saleNum" label="销量" />
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNo"
        background
        layout="prev, pager, next, jumper"
        :total="pageCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { findTheGoodSales, findTheGoodSalesCount } from "../api/index";
export default {
  data() {
    return {
      goodsData: [],
      pageNo: 1,
      pageSize: 10,
      pageCount: 0,
      dateTime: "",
      startDate: "",
      endDate: "",
      value1: "",
      options1: [{ value: "asc", label: "升" }, { value: "desc", label: "降" }],
      status: "",
    };
  },
  created() {
    this.findTheGoodSales();
  },
  methods: {
    findTheGoodSales(startDate, endDate, sortOrder) {
      findTheGoodSales({
        goodsId: this.$route.query.goodsId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        startDate: startDate,
        endDate: endDate,
        orderBy: "saleNum",
        sortOrder: sortOrder,
      }).then((res) => {
        findTheGoodSalesCount({
          goodsId: this.$route.query.goodsId,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          startDate: startDate,
          endDate: endDate,
          orderBy: "saleNum",
          sortOrder: sortOrder,
        }).then((res) => {
          if (res.code == 1) {
            this.pageCount = res.data;
            console.log(this.pageCount);
          } else if (res.code == -1) {
            this.goodsData = [];
          } else if (res.code == 2) {
            this.$router.push("/");
            this.$message.error(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
        if (res.code == 1) {
          this.goodsData = res.data;
        } else if (res.code == -1) {
          this.goodsData = [];
        } else if (res.code == 2) {
          this.$router.push("/");
          this.$message.error(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    search() {
      this.pageNo = 1;
      this.status = 1;
      this.findTheGoodSales(this.startDate, this.endDate, this.value1);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      if (this.status == 1) {
        this.findTheGoodSales(this.startDate, this.endDate, this.value1);
      } else {
        this.findTheGoodSales();
      }
    },
    dateTimeChange(date) {
      if (!date) {
        this.startDate = "";
        this.endDate = "";
        this.findTheGoodSales();
        return;
      }
      this.startDate = date[0];
      this.endDate = date[1];
    },
  },
};
</script>

<style lang="less" scoped>
#goodsDetail {
  padding: 20px;
}
.el-pagination {
  margin-top: 20px;
}
</style>
